import { Box, breakpoint, color, H2, Text } from '@bfa/common-ui';
import React from 'react';
import styled from 'styled-components';

import { GQLLayoutContent } from '../../../../gql.generated';
import BulletedList from '../BulletedList';

const TextWithDots = styled(Text)`
  display: inline-block;
  & > span {
    font-size: 0.3rem;
    display: inline-block;
    vertical-align: middle;
  }
  @media only screen and (min-width: ${breakpoint('sm')}) {
    & :first-child {
      display: inline;
    }
  }
`;

const ClickeablePinkSpan = styled.span`
  color: ${color('gbDarkest')};
  cursor: pointer;
  display: inline-block;
  line-height: 1.5;
  @media only screen and (min-width: ${breakpoint('sm')}) {
    display: inline;
  }
`;

const StyledText = styled(Text).attrs({
  bold: true,
})`
  color: ${color('iconBoxDarkest')};
`;

export const CONTENT_TITLE_ID = 'content-title';
export const CONTENT_LINK_ID = 'content-link';

const Content = ({
  gbxOneClickUpgradePage,
  shouldSeelearnMoreModal,
  toggleModal,
}: {
  gbxOneClickUpgradePage?: GQLLayoutContent['gbxOneClickUpgradePage'];
  shouldSeelearnMoreModal?: boolean;
  toggleModal?: any;
}) => {
  const {
    landingHeader,
    landingExplanatory,
    landingValueProperty,
    landingBulletsPoints,
  } = gbxOneClickUpgradePage || {};

  return (
    <Box>
      {landingHeader && <H2 marginBottom="1rem">{landingHeader}</H2>}
      {landingExplanatory && (
        <StyledText as="h3" data-testid={CONTENT_TITLE_ID}>
          {landingExplanatory}
        </StyledText>
      )}
      {(landingValueProperty || shouldSeelearnMoreModal) && (
        <Box marginTop="1rem">
          <TextWithDots
            as="span"
            dangerouslySetInnerHTML={{ __html: landingValueProperty ?? '' }}
          />
          <ClickeablePinkSpan
            data-testid={CONTENT_LINK_ID}
            onClick={toggleModal}
          >
            &nbsp;Learn More
          </ClickeablePinkSpan>
        </Box>
      )}
      <BulletedList bulletsPoints={landingBulletsPoints} />
    </Box>
  );
};

export default Content;
